import axios from 'axios';

import {
    BACKEND_URL
} from "../backendURL";

class NewsService {

    getNewsList(filters) {
        const searchFilters = filters.searchFilters;
        const pagination = filters.pagination;
        const limit = pagination.pageSize;
        const offset = pagination.pageSize * (pagination.currentPage - 1);
        const params = { ...searchFilters, offset: offset, limit: limit };
        let tok = localStorage.getItem('authUser')
        let token = JSON.parse(tok)
        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
            params: params
        };
        return axios.get(BACKEND_URL + "/api/news/news/", config);
    };

}

export default new NewsService()


